const getters = {
  token: state => state.user.token,
  roles: state => state.user.roles,
  menu: state => state.permission.menu,
  permission_routes: state => state.permission.routes,
  logoUrl: state => state.app.logoUrl,
  manualPath: state => state.app.manualPath,
  icoUrl: state => state.app.icoUrl,
  shortName: state => state.app.shortName,
  name: state => state.app.name,
  recordInfo: state => state.app.recordInfo,
  aiIdentity: state => state.app.aiIdentity,
  aiLogoUrl: state => state.app.aiLogoUrl,
  aiWebsite: state => state.app.aiWebsite,
  contract: state => state.app.contract
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js